module.exports = __webpack_public_path__ + "img/codigo.6db7b746.jpeg";